// extracted by mini-css-extract-plugin
module.exports = {"header":"ColorPalette_header__3jmbG","colors":"ColorPalette_colors__1HVVv"};